/* eslint-disable */
if (typeof window !== 'undefined' && window.render_swatch_url) {
  const colorSwatchID = document.getElementById("productswatch");
if (colorSwatchID && window.render_swatch_url) {
  fetch(window.render_swatch_url)
    .then((response) => response.text())
    .then((html) => {
      colorSwatchID.innerHTML = html;
      const alpineData = colorSwatchID.__x;
      if (alpineData) {
        alpineData.swatchesLoaded = true;
      }
    })
    .catch((error) => console.error('Error loading section:', error));
} else {
  console.warn('Color Swatch not found or render_swatch_url missing');
}
}

document.addEventListener('alpine:init', () => {
  Alpine.store('disableAddToCart', false);

  Alpine.data('mainProduct', () => ({
    loading: false,
    init() {
      document.addEventListener('liquid-ajax-cart:request-start', (event) => {
        const { requestState } = event.detail;
        const { requestType } = requestState;
        if (requestType === 'add') {
          this.loading = true;
        }
      });

      document.addEventListener('liquid-ajax-cart:request-end', (event) => {
        const { requestState } = event.detail;
        const { requestType, responseData } = requestState;
        if (requestType === 'add') {
          this.loading = false;
        }
        // Check if the request is an 'add' and the response is successful
        if (requestType === 'add' && responseData?.ok) {
          window.dispatchEvent(new CustomEvent('openMiniCart', { detail: true }));
        }
        // Check if the request is an 'add' and the response is unsuccessful
        if (requestType === 'add' && responseData?.ok === false) {
          const productPageError = document.querySelector('.product-page-error');
          if (productPageError) {
            productPageError.style.display = 'block';
          }
        }
      });
    }
  }));
});

/* eslint-enable */
